"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Table.css");
var _dist = require("package_ui_ihm/dist");
var _Table2 = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : EquipmentPtuUse.js
* Description : Ce fichier contient la définition du composant EquipmentPtuUse
*               Ce composant affiche un tableau avec les informations d'utilisations des cartes LEDs de chaque PTU
* Date de création : 14 avril 2026
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* EquipmentPtuUse : ce composant affiche un tableau avec les informations d'utilisations des cartes LEDs de chaque PTU
*
* Type : composant 
*
* Parametres : 
*  - ptuTimeWorking -- temps d'utilisation des PTUs
*  - ptus -- sous ensemble : PTU d'un boxitunnel, d'un boxilab ou d'un boxistick
*/function EquipmentPtuUse(_ref) {
  var ptuTimeWorking = _ref.ptuTimeWorking,
    ptus = _ref.ptus;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
    component: _Paper["default"],
    className: "margin-bottom margin-top table-border",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table2["default"], {
      sx: {
        minWidth: 280
      },
      size: "small",
      "aria-label": "a dense table",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              className: "table-label"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              className: "table-label",
              children: "Mise en service"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              className: "table-label",
              children: "Temps d'\xE9clairage"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              className: "table-label",
              children: "Usure des Leds"
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
        children: ptuTimeWorking && ptuTimeWorking.length !== 0 ? ptuTimeWorking.sort(function (a, b) {
          return a.module_id > b.module_id ? 1 : -1;
        }).map(function (ptu_time_working) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            sx: {
              '&:last-child td, &:last-child th': {
                border: 0
              }
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                className: "zero-marge-padding",
                children: ["PTU ", ptu_time_working.module_id]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                className: "zero-marge-padding",
                children: "Non renseign\xE9"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                className: "zero-marge-padding",
                children: [ptu_time_working.time_working.toFixed(2), " h"]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              component: "th",
              scope: "row",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                className: "zero-marge-padding",
                children: [(ptu_time_working.time_working * 0.5).toFixed(2), " h"]
              })
            })]
          }, ptu_time_working.module_id);
        }) : ptus.sort(function (a, b) {
          return a.port > b.port ? 1 : -1;
        }).map(function (ptu) {
          return ptu.led_cards.map(function (led_card) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              sx: {
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                  className: "zero-marge-padding",
                  children: ["PTU ", Number(ptu.port), " - carte LED ", led_card.serial_number]
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  className: "zero-marge-padding",
                  children: "Non renseign\xE9"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                  className: "zero-marge-padding",
                  children: [(led_card.time_lighting / 3600).toFixed(2), " h"]
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                  className: "zero-marge-padding",
                  children: [(led_card.time_working / 3600).toFixed(2), " h"]
                })
              })]
            }, led_card.id);
          });
        })
      })]
    })
  });
}
var _default = exports["default"] = EquipmentPtuUse;